import { render, staticRenderFns } from "./TransactionTypes.vue?vue&type=template&id=2b38285e&scoped=true&"
import script from "./TransactionTypes.vue?vue&type=script&lang=js&"
export * from "./TransactionTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b38285e",
  null
  
)

export default component.exports